import React, { Component } from 'react'
import { Row } from 'reactstrap'

import logo from '../img/logo.svg'
import '../App.css'

class Header extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <Row className="App-header-text">
            Your community,<br />
            in a single touch.
          </Row>
        </header>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js